export const routeName = 'faq';
export const slugs: Record<string, string> = {
	es: 'preguntas-frecuentes',
	en: 'faq',
	ca: 'preguntes-frequents',
	fr: 'questions-frequentes',
	it: 'domande-frequenti',
};
export const sitemap = { changefreq: 'monthly', priority: '0.6', lastmod: '2026-09-02' };
